export default __webpack_public_path__ + "static/media/one-maxi.968c226a.glb";